import * as React from 'react';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useSelector } from 'react-redux';
import { isNil } from 'lodash';
import { RootState } from 'modules';
import NotificationMessage from 'components/modal/NotificationMessage';
import { useDidMount } from 'libs/hooks';
import GlobalStyles from 'GlobalStyles';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Core: React.FC = () => {
  const didMount = useDidMount();
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);

  useEffect(() => {
    if (isNil(currentUser) === false) {
      (window as any).Beacon &&
        (window as any).Beacon('identify', {
          name: 'Bigstep',
        });
    }
  }, [didMount]);

  return (
    <>
      {/* 디폴트 타이틀 */}
      <Helmet>
        <title>컨설팅 취업준비의 모든 것, 커리어스텝</title>
        <meta name='description' content='Career Step' />
        <meta property='og:title' content='Career Step' />
        <meta property='og:description' content='Career Step' />
      </Helmet>
      <GlobalStyles />
      <NotificationMessage />
    </>
  );
};

export default Core;
